"use strict"

var headerMenu = {
    init: () => {
        headerMenu.setActiveMainMenu();
        headerMenu.disableMenu();
    },
    setActiveMainMenu: () => {
        var menuList = document.querySelectorAll(".header-list-menu .header-menu");

        menuList.forEach((item) => {
            item.addEventListener('click', () => {
                var dataLabel = item.getAttribute("data-label");
                headerMenu.removeActive(".header-list-menu .header-menu"); // remove active main header
                item.classList.add('active'); // set active main header
                var isActive = headerMenu.selectedActive(dataLabel);
                headerMenu.setActiveSubmenu(isActive, dataLabel); //set active/not sub menu
            });

            item.addEventListener('mouseover', () => {
                var dataLabel = item.getAttribute("data-label");
                headerMenu.removeActive(".header-list-menu .header-menu"); // remove active main header
                item.classList.add('active'); // set active main header
                var isActive = headerMenu.selectedActive(dataLabel);
                headerMenu.setActiveSubmenu(isActive, dataLabel); //set active/not sub menu
            });
        });
    },
    setActiveSubmenu: (isActive, dataLabel) => {
        var subHeader = document.querySelector("#subHeader");
        var subMenuAll = document.querySelectorAll("div .sub-header-content");
        var subIdName = document.querySelector("#" + dataLabel);

        setTimeout(function () {
            // enable/disable sub menu header per item
            subMenuAll.forEach((item) => {
                item.classList.add("d-none"); // disable sub header menu
                if (subIdName != null) {
                    var itemName = item.id;
                    if (subIdName.id == itemName) {
                        item.classList.remove("d-none"); // enable sub header menu

                        // set active sub menu header
                        var nameElement = "#" + itemName + " ul li";
                        var subMenuList = document.querySelectorAll(nameElement);

                        subMenuList.forEach((subItem) => {
                            subItem.addEventListener('click', () => {
                                var dataLabelSub = subItem.getAttribute("data-label");
                                var dataLabelSubChild = subItem.getAttribute("data-label-child");
                                headerMenu.removeActive(nameElement); // remove active sub header
                                subItem.classList.add("active");

                                if (dataLabelSubChild != null) {
                                    var isActive = headerMenu.selectedActive(dataLabelSubChild);
                                    headerMenu.setActiveSubSubmenu(isActive, dataLabelSub, dataLabelSubChild); //set active/not sub menu
                                } else {
                                    headerMenu.setActiveSubSubmenu(false, "null", "null"); //set active/not sub sub menu

                                    var dataLink = subItem.getAttribute("data-href");
                                    var dataTarget = subItem.getAttribute("data-target");
                                    if (dataTarget) {
                                        window.open(dataLink, '_blank');
                                    } else {
                                        window.location.href = dataLink;
                                    }
                                }
                            });

                            subItem.addEventListener('mouseover', () => {
                                var dataLabelSub = subItem.getAttribute("data-label");
                                var dataLabelSubChild = subItem.getAttribute("data-label-child");
                                headerMenu.removeActive(nameElement); // remove active sub header
                                subItem.classList.add("active");

                                if (dataLabelSubChild != null) {
                                    var isActive = headerMenu.selectedActive(dataLabelSubChild);
                                    headerMenu.setActiveSubSubmenu(isActive, dataLabelSub, dataLabelSubChild); //set active/not sub menu
                                } else {
                                    headerMenu.setActiveSubSubmenu(false, "null", "null"); //set active/not sub sub menu
                                }
                            });
                        });
                    }
                } else {
                    headerMenu.setActiveSubSubmenu(false, "null", "null"); //set active/not sub sub menu
                }
            });

            // open/close menu sub header
            if (subHeader) {
                isActive == true ? subHeader.classList.remove('d-none') : subHeader.classList.add('d-none');
            }

        }, 150);
    },
    setActiveSubSubmenu: (isActive, dataLabel, dataLabelSub) => {
        var subSubHeader = document.querySelector("#subSubHeader");
        var subSubHeaderChild = document.querySelectorAll("#subSubHeader .sub-sub-header-content");

        setTimeout(() => {
            // open/close sub sub header
            isActive == true ? subSubHeader.classList.remove('d-none') : subSubHeader.classList.add('d-none');

            subSubHeaderChild.forEach((item) => {
                item.classList.add("d-none");
                // open sub sub header
                if (dataLabel == item.id) {
                    item.classList.remove("d-none");
                    // open choose content sub sub header
                    var subSub = document.querySelectorAll("#" + dataLabel + " .last-child-header");
                    subSub.forEach((sub) => {
                        sub.classList.add("d-none");
                        // open content from sub sub header
                        if (dataLabelSub == sub.id) {
                            sub.classList.remove("d-none")

                            var dataHref = document.querySelectorAll("#" + sub.id + " ul li.sub-header-menu");
                            dataHref.forEach((link) => {
                                link.addEventListener("click", () => {
                                    var dataLink = link.getAttribute("data-href");
                                    if (dataLink.includes('')) {
                                        window.open(dataLink, '_blank');
                                    } else {
                                        window.location.href = dataLink;
                                    }
                                });
                            });
                        }
                    });
                }
            });
        }, 150);
    },
    removeActive: (classElement) => {
        var menuList = document.querySelectorAll(classElement);

        menuList.forEach((item) => {
            item.classList.remove('active');
        });
    },
    selectedActive: (label) => {
        var list = ["dealerMenu", "grMenu", "tlsMenu"];

        if (["spTools", "afterSales"].includes(label)) {
            document.querySelector("#subSubHeader").classList.add("d-none");
        }

        return !list.includes(label);
    },
    disableMenu: () => {
        var body = document.querySelector("#body-content");
        if (body != null) {
            body.addEventListener('click', () => {
                headerMenu.setActiveSubmenu(false);
                headerMenu.removeActive(".header-list-menu .header-menu");
            });
            body.addEventListener('mouseover', () => {
                headerMenu.setActiveSubmenu(false);
                headerMenu.removeActive(".header-list-menu .header-menu");
            });
        }
    }
}

var headerMenuMobile = {
    init: () => {
        headerMenuMobile.openMenu();
        headerMenuMobile.closeMenu();
        headerMenuMobile.chooseMenu();
    },
    openMenu: () => {
        var menu = document.querySelector("#header-mobile-icon");
        var menuList = document.querySelector("#headerContentMobile");
        if (menu != null) {
            menu.addEventListener("click", () => {
                menuList.classList.toggle("d-none");
            });
        }
    },
    closeMenu: () => {
        var closeMenu = document.querySelectorAll(".mobile-menu-times-icon");
        var menuList = document.querySelector("#headerContentMobile");
        var subMenuList = document.querySelector("#subHeader");
        var subSubMenuList = document.querySelector("#subSubHeader");
        var backSubMenu = document.querySelector("#subHeaderBack");
        var backSubSubMenu = document.querySelectorAll(".subSubHeaderBack");

        closeMenu.forEach((item) => {
            item.addEventListener("click", () => {
                menuList.classList.add("d-none");
                subMenuList.classList.add("d-none");
                subSubMenuList.classList.add("d-none");
            });
        });

        if (backSubMenu != null) {
            backSubMenu.addEventListener("click", () => {
                subMenuList.classList.add("d-none");
            });

            backSubSubMenu.forEach((item) => {
                item.addEventListener("click", () => {
                    subSubMenuList.classList.add("d-none");
                });
            });
        }
    },
    chooseMenu: () => {
        var menuList = document.querySelectorAll("#headerContentMobile ul li");
        var subMenuList = document.querySelector("#subHeader");

        menuList.forEach((item) => {
            item.addEventListener("click", () => {
                subMenuList.classList.remove("d-none");

                var dataLabel = item.getAttribute("data-label");
                var subtitle = item.getAttribute("data-title");
                document.querySelector("#subHeaderTitle").innerHTML = subtitle;

                headerMenuMobile.chooseSubMenu(dataLabel);
            });
        })
    },
    chooseSubMenu: (dataLabel) => {
        var subSubMenuList = document.querySelector("#subSubHeader");
        var subMenuContent = document.querySelectorAll("#subHeader .sub-header-content");

        subMenuContent.forEach((items) => {
            items.classList.add("d-none");

            if (items.id == dataLabel) {
                items.classList.remove("d-none");
            }
        });

        var subMenuList = document.querySelectorAll("#" + dataLabel + " ul li");
        subMenuList.forEach((item) => {
            item.addEventListener("click", () => {
                var dataHref = item.getAttribute("data-href");
                var dataSubLabel = item.getAttribute("data-label");
                var dataSubLabelChild = item.getAttribute("data-label-child");
                var dataSubTitle = item.getAttribute("data-title");
                var titleSubMenu = document.querySelectorAll(".subSubHeaderTitle");

                if (dataHref != null) {
                    window.location.href = dataHref;
                } else {
                    subSubMenuList.classList.remove("d-none");

                    titleSubMenu.forEach((tet) => {
                        tet.innerHTML = dataSubTitle;
                    });

                    var subSub = document.querySelectorAll("#subSubHeader .sub-sub-header-content");
                    subSub.forEach((sub) => {
                        sub.classList.add("d-none");
                    });
                    document.querySelector("#" + dataSubLabel).classList.remove("d-none");

                    var subsub = document.querySelectorAll("#" + dataSubLabel + " .last-child-header");
                    subsub.forEach((subs) => {
                        subs.classList.add("d-none");

                        if (subs.id == dataSubLabelChild) {
                            subs.classList.remove("d-none");

                            headerMenuMobile.chooseSubSubMenu(subs.id);
                        }
                    });
                }
            });
        });
    },
    chooseSubSubMenu: (dataId) => {
        var subssub = document.querySelectorAll("#" + dataId + " ul li");

        subssub.forEach((item) => {
            item.addEventListener("click", () => {
                var dataHref = item.getAttribute("data-href");
                if (dataHref != null) {
                    window.location.href = dataHref;
                }
            });
        });
    }
}

var floatingButton = {
    init: () => {
        var button = document.querySelector("#floatingButton");
        var icon = document.querySelector("#floatingIcon");

        if (button != null) {
            button.addEventListener("click", () => {
                button.classList.toggle("active");

                if (button.classList.contains("active")) {
                    icon.classList.remove("bx-comment-dots");
                    icon.classList.add("bx-chevron-down");
                } else {
                    icon.classList.add("bx-comment-dots");
                    icon.classList.remove("bx-chevron-down");
                }
            });
        }
    }
}

var lazyLoad = {
    init: () => {
        // lazy load
        let lazy = document.querySelector(".lazy");
        if (lazy) {
            $('.lazy').Lazy({
                scrollDirection: 'vertical',
                effect: 'fadeIn',
                visibleOnly: true,
                onError: function (element) {
                    console.log('error loading ' + element.data('src'));
                }
            });
        }
    }
}

var homeJs = {
    init: () => {
        homeJs.vehicleModels();
    },
    vehicleModels: () => {
        var button = document.querySelectorAll(".category-vehicle button");

        button.forEach((item) => {
            item.addEventListener("click", () => {
                button.forEach((items) => {
                    items.classList.remove("active");
                });

                item.classList.add("active");

                homeJs.loadingModel();
            });
        });
    },
    loadingModel: () => {
        // var content = document.querySelector("#item-models");
        // var loader = document.querySelector(".vehicle-item-loader");

        // content.classList.add("d-none");
        // loader.style.cssText = "display:flex; align-items:center; justify-content:center; height:285px;";
        // loader.classList.remove("d-none");

        setTimeout(function () {
            // content.classList.remove("d-none");
            // loader.classList.add("d-none");
        }, 300);
    }
}

var owlSlider = {
    init: function () {
        this.lineupSlider();
        this.justCarousel();
    },
    lineupSlider: function () {
        window.owl = $('.owl-lineup').owlCarousel({
            margin: 20,
            items: 4,
            center: true,
            loop: true,
            responsiveClass: true,
            responsive: {
                0: {
                    items: 3,
                    nav: false,
                },
                600: {
                    items: 5,
                    nav: false,
                },
                1000: {
                    items: 7,
                    nav: true,
                    stagePadding: 50,
                }
            },
        });
        $(".owl-lineup .owl-prev").html("<i class='bx bx-chevron-left'></i>");
        $(".owl-lineup .owl-next").html("<i class='bx bx-chevron-right'></i>");
    },
    justCarousel: function () {
        window.banner = $('.single-banner').slick({
            dots: true,
            arrows: false,
            autoplay: true,
            autoplaySpeed: 3000,
            adaptiveHeight: true
        });
    }
}

var newHeader = {
    init: function () {
        this.scrollNavbar();
        this.clickMenu();
        this.hoverMenu();
        this.buttonVehicle();
        this.mobileHeader();
    },
    scrollNavbar: function () {
        let navbar = document.querySelector("header.new-header");
        $(window).scroll(function() {
            var scroll = $(window).scrollTop();
            if (scroll < 70) {
                navbar.classList.remove("must-sticky");
            } else {
                navbar.classList.add("must-sticky");
            }
        });
    },
    clickMenu: function () {
        let navbar = document.querySelector("header.new-header");
        let menus = document.querySelectorAll(".toyota-menu-toggler.has-dropdown");
        let owners = document.querySelector('.ownership-menu-divider');
        let subOwners = document.querySelector('#ownershipSubMenu2');
        let mores = document.querySelector('.more-menu-divider');
        let subMores = document.querySelector('#moreSubMenu2');
        let vehicleModel = document.querySelector('#vehiclesHeaderMenu');

        menus.forEach(item => {
            item.addEventListener('click', (e) => {
                e.preventDefault();
                let att = item.getAttribute('data-target');

                if (att.includes('vehicles')) {
                    vehicleModel.classList.toggle('active');
                    document.querySelector('body').classList.toggle('overflow-hidden');
                } else {
                    vehicleModel.classList.remove('active');
                    document.querySelector('body').classList.remove('overflow-hidden');
                    document.querySelector('body').classList.add('overflow-auto');
                }

                menus.forEach(items => {
                    let att2 = items.getAttribute('data-target');
                    if (att !== att2) items.classList.remove('expand');
                });
                
                navbar.classList.toggle('bg-white');
                item.classList.toggle('expand');
                owners.classList.remove('d-flex');
                subOwners.classList.remove('d-block');
                mores.classList.remove('d-flex');
                subMores.classList.remove('d-block');

                // enable lazy load
                $('.lazy').Lazy();
            })
        });
    },
    hoverMenu: function () {
        let listMenu = document.querySelectorAll(".submenu-item");
        let owners = document.querySelector('.ownership-menu-divider');
        let subOwners = document.querySelector('#ownershipSubMenu2');
        let mores = document.querySelector('.more-menu-divider');
        let subMores = document.querySelector('#moreSubMenu2');

        listMenu.forEach(item => {
            item.addEventListener('mouseover', () => {
                let dataTarget = item.getAttribute("data-target");
                let typeMenu = item.classList.value;
                
                if(dataTarget !== null) {
                    if (typeMenu.toString().includes('ownership')) {
                        owners.classList.add('d-flex');
                        subOwners.classList.add('d-block');
                        // clear
                        document.querySelectorAll(".ownership-submenu2-container").forEach(_item => {
                            _item.classList.remove('d-block');
                        });
                        
                        document.querySelector(dataTarget).classList.add('d-block');
                    }
                    if (typeMenu.toString().includes('more-menu')) {
                        mores.classList.add('d-flex');
                        subMores.classList.add('d-block');
                        // clear
                        document.querySelectorAll(".more-submenu2-container").forEach(_item => {
                            _item.classList.remove('d-block');
                        });

                        document.querySelector(dataTarget).classList.add('d-block');
                    }
                } else {
                    if (typeMenu.toString().includes('ownership')) {
                        owners.classList.remove('d-flex');
                        subOwners.classList.remove('d-block');
                    }
                    if (typeMenu.toString().includes('more-menu')) {
                        mores.classList.remove('d-flex');
                        subMores.classList.remove('d-block');
                    }
                }
            })
        })
    },
    buttonVehicle: function () {
        // looping 3 component to show display vehicles
        for (let index = 1; index <= 3; index++) {
            let buttons = document.querySelectorAll("#productLineupSelector-"+index+" button");
            let vehicles = document.querySelectorAll(".model-vehicles-"+index);
            
            let no = 1;
            buttons.forEach(item => {
                // set default click varian car, ex: ev, gr dll
                if (no == 1) {
                    let dataTarget = item.getAttribute('data-target');
                    // click varian car, ex: ev, gr dll
                    let nameVarian = dataTarget.replace('Collapse', '');
                    this.selectorVarianCar(nameVarian);
                }

                item.addEventListener('click', () => {
                    buttons.forEach(_item => {
                        _item.classList.remove('active');
                    });
                    
                    item.classList.toggle('active');
                    
                    vehicles.forEach(val => {
                        val.classList.remove('d-block');
                        val.classList.add('d-none');
                    });
                    let dataTarget = item.getAttribute('data-target');
                    document.querySelector("#"+dataTarget).classList.add('d-block');
                    document.querySelector("#"+dataTarget).classList.remove('d-none');

                    // click varian car, ex: ev, gr dll
                    let nameVarian = dataTarget.replace('Collapse', '');
                    this.selectorVarianCar(nameVarian);

                    // enable lazy load
                    $('.lazy').Lazy();
                });

                no++;
            });
        }
    },
    selectorVarianCar: function(nameVarian) {
        // check data variant vehicle
        let modelVarian = document.querySelectorAll("#Collapse"+nameVarian+" .ALL");
        let ev = 0;
        let gr = 0;
        modelVarian.forEach(item => {
            if (item.classList.value.includes("EV")) ev++;
            if (item.classList.value.includes("GR")) gr++;
        });
        
        let buttonVarianCar = document.querySelectorAll("#ProductLineup"+ nameVarian +" button");
        buttonVarianCar.forEach(item => {
            let varian = item.getAttribute('data-variant');
            let target = item.getAttribute('data-target');

            // hide button selector variant vehicles
            if (varian.includes("EV") && ev == 0) item.classList.add("d-none");
            if (varian.includes("GR") && gr == 0) item.classList.add("d-none");

            // click button selector variant vehicles
            item.addEventListener('click', () => {
                // active / not button varian model
                buttonVarianCar.forEach(_item => {
                    _item.classList.remove("active");
                });
                item.classList.toggle("active");

                // show / hide varian car display
                if (varian.includes("ALL")) {
                    variant_hide(target);
                    variant_show(target, "ALL");
                }
                if (varian.includes("EV")) {
                    variant_hide(target);
                    variant_show(target, "EV");
                }
                if (varian.includes("GR")) {
                    variant_hide(target);
                    variant_show(target, "GR");
                }
            });
        });

        function variant_hide(target) {
            let allDisplay = document.querySelectorAll("#"+target+" .ALL");
            allDisplay.forEach(all => {
                all.classList.add("d-none");
            });
        }
        function variant_show(target, varian) {
            let evDisplay = document.querySelectorAll("#"+target+" ."+varian);
            evDisplay.forEach(ev => {
                ev.classList.remove("d-none");
            });
        }
    },
    mobileHeader: function () {
        let menuHeader = document.querySelector("#mobileMenuHeader");
        let iconHeader = document.querySelector("#mobileOpenIcon");
        let mobileHeader = document.querySelector("#mobileMenu");
        let iconClose = document.querySelector("#mobileCloseIcon");
        let mainMenu = document.querySelector("#mainMenuContainer");
        let listMenu = document.querySelectorAll(".mobile-main-menu.has-child");
        let iconPrev = document.querySelectorAll(".mobile-submenu-container .fa.fa-chevron-left");
        let iconSubClose = document.querySelectorAll(".mobile-submenu-container .fa.fa-times");
        let subMenu = document.querySelectorAll(".mobile-submenu-container");
        let subMenuMobile = document.querySelectorAll(".mobile-submenu-item.submenu-has-child");

        iconHeader.addEventListener('click', () => {
            mobileHeader.classList.toggle('expand');
            document.querySelector('body').classList.toggle('overflow-hidden');
        });

        iconClose.addEventListener('click', () => {
            mobileHeader.classList.toggle('expand');
            document.querySelector('body').classList.toggle('overflow-hidden');
        });
        iconSubClose.forEach(item => {
            item.addEventListener('click', () => {
                menuHeader.classList.toggle('d-none');
                mobileHeader.classList.remove('expand');
                document.querySelector('body').classList.remove('overflow-hidden');
                subMenu.forEach(items => {
                    items.classList.remove('d-block');
                    items.classList.add('d-none');
                });
                mainMenu.classList.toggle('d-none');
            });
        });

        listMenu.forEach(item => {
            item.addEventListener('click', () => {
                menuHeader.classList.add('d-none');
                mainMenu.classList.add('d-none');
                let dataTarget = item.getAttribute('data-target');
                if (dataTarget !== null) {
                    document.querySelector(dataTarget).classList.add('d-block');
                }
            });
        });

        iconPrev.forEach(item => {
            item.addEventListener('click', () => {
                menuHeader.classList.remove('d-none');
                mainMenu.classList.remove('d-none');

                subMenu.forEach(items => {
                    items.classList.remove('d-block');
                    items.classList.add('d-none');
                });
            });
        });

        subMenuMobile.forEach(item => {
            item.addEventListener('click', () => {
                subMenuMobile.forEach(_item => {
                    _item.classList.remove('expand');
                });

                item.classList.toggle('expand');
            });
        });
    }
}

let slickSlider = {
    init: function () {
        var canUnslick = false;
        var canSlick = true;
        var initWidht = window.screen.width;
        if (initWidht < 525) {
            canUnslick = true;
            canSlick = false;
            slickSlider.slickify('#productLineupSelector-1');
        }
        addEventListener("resize", (event) => {
            var $windowWidth = window.screen.width;
            if ($windowWidth < 525) {
                if (canSlick) {
                    canUnslick = true;
                    canSlick = false;
                    slickSlider.slickify('#productLineupSelector-1');
                }
            } else {
                if (canUnslick) {
                    canUnslick = false;
                    canSlick = true;
                    $('#productLineupSelector-1').slick('unslick');
                }
            }
        });
    },
    slickify: function (element) {
        $(element).slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            infinite: false,
            dots: false,
            responsive: [{
                breakpoint: 425,
                settings: {
                    slidesToShow: 2,
                    dots: false
                }
            }]
        });
    }
}

let footerFunc = {
    init: function () {
        this.gotop();
        this.clickFooter();
    },
    gotop: function () {
        document.querySelector("#gotop").addEventListener('click', () => {
            document.body.scrollTop = 0; // For Safari
            document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
        });
    },
    clickFooter: function () {
        let menuFooter = document.querySelectorAll(".footer-menu-container");

        menuFooter.forEach(item => {
            item.addEventListener('click', () => {
                item.classList.toggle('expand');
            });
        });
    }
}

var scrollReveal = {
    init: function() {
        window.sr = ScrollReveal({
            reset: false,  
            origin: 'top',
            distance: '80px',
            duration: 2000
        });
		sr.reveal('.title-display', {origin: 'bottom', delay: 100});
        sr.reveal('.subtitle-display', {origin: 'bottom', delay: 120});
        sr.reveal('.text-architecture', {origin: 'bottom', interval: 100});
        sr.reveal('.img-architecture', {origin: 'right'});
        sr.reveal('.domains-up', {origin: 'bottom', delay: 250, interval: 200});
        sr.reveal('.domains-right', {origin: 'right', delay: 250, interval: 200});
        sr.reveal('.domains-left', {origin: 'left', delay: 250, interval: 200});

        window.engine = ScrollReveal({
            reset: false,
            distance: '200px'
        });
        engine.reveal('.engine-text', {origin: 'left', delay: 100, interval: 200});
        engine.reveal('.engine-img-left-1', {origin: 'left', delay: 100, duration: 2000});
        engine.reveal('.engine-up-1', {origin: 'bottom', delay: 100, duration: 1000, interval: 200});
        engine.reveal('.engine-up-2', {origin: 'bottom', delay: 100, duration: 1000, interval: 200});
        engine.reveal('.engine-img-right-1', {origin: 'right', delay: 2100, duration: 1000});
        engine.reveal('.engine-up-3', {origin: 'bottom', delay: 100, duration: 1000, interval: 200});
        engine.reveal('.engine-img-left-2', {origin: 'left', delay: 2100, duration: 1000});
        engine.reveal('.engine-up-4', {origin: 'bottom', delay: 100, duration: 1000, interval: 200});
        engine.reveal('.engine-img-left-3', {origin: 'left', delay: 2100, duration: 1000});
        engine.reveal('.engine-img-right-2', {origin: 'right', delay: 2100, duration: 1000});
        engine.reveal('.engine-img-right-3', {origin: 'right', delay: 2100, duration: 1000});

        this.navAccessories();
        this.navBrochure();
    },
    navAccessories: function () {
        const navList = document.querySelectorAll("#nav-accessories a");
        
        navList.forEach(item => {
            const target = item.getAttribute("data-target");

            item.addEventListener("click", () => {
                navList.forEach(items => {
                    items.classList.remove('active');
                });
                item.classList.add("active");

                const targets = item.getAttribute("data-target");
                const targetList = document.querySelectorAll(".daccessories .container");
                targetList.forEach(list => {
                    list.classList.remove("active");
                });
                document.querySelector("#"+targets).classList.add("active");
            });
        });
    },
    navBrochure: function() {
        const nvmenu = document.querySelectorAll(".nvmenu a.nav-link");

        nvmenu.forEach(item => {
            var screen = window.innerWidth;
            
            item.addEventListener("click", () => {
                nvmenu.forEach(_item => {
                    _item.classList.remove("active");
                });
                item.classList.add("active");

                const targets = item.getAttribute("data-target");
                const targetList = document.querySelectorAll(".ebrochure .container-fluid");

                if (screen > '575') {

                    targetList.forEach(list => {
                        list.classList.remove("active");
                    });
                    document.querySelector("#dbrochure"+targets).classList.add("active");
                    document.querySelector("#discoverModel").scrollIntoView();
                    $('.lazy').Lazy();

                } else { //mobile

                    var targetView = document.querySelector("#dbrochure"+targets);
                    targetView.scrollIntoView();

                }
            });

        });
    }
}
    

$(function () {
    lazyLoad.init();

    newHeader.init();
    slickSlider.init();
    footerFunc.init();

    // headerMenu.init();
    // headerMenuMobile.init();
    floatingButton.init();
    homeJs.init();
    owlSlider.init();

    scrollReveal.init();

    $(function () {
        $('[data-toggle="tooltip"]').tooltip();
    });

    $('.menu-tracking').on('click', function() {
        dataLayerPush($(this).attr('meta-name') != undefined ? $(this).attr('meta-name') : $(this).text(), $(this).attr('menu-position'), $(this).attr('href') != undefined ? $(this).attr('href') : '', $(this).attr('meta-title') != undefined ? $(this).attr('meta-title') : '');
    })

    $('.footer-menu-tracking').on('click', function() {
        footerMenuPush($(this).attr('meta-name') != undefined ? $(this).attr('meta-name') : $(this).text(), $(this).attr('href') != undefined ? $(this).attr('href') : '');
    })

    $('.car-tracking').on('click', function(){
        dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
        dataLayer.push({
            event: "view_item_list",
            event_category: "Ecommerce",
            ecommerce: {
                items: JSON.parse($(this).attr('data-car'))
            }
        });
    });
});

function dataLayerPush(name, position, url, title) {
    dataLayer.push({
        'event': 'panel_tracking',
        'event_category': 'Panel Tracking',
        'panel_name': name,
        'panel_position': 'Slot '+position,
        'panel_page_url': url,
        'panel_page_title': title
    });
}

function footerMenuPush(name, url) {
    dataLayer.push({
        'event': 'footer_click',
        'event_category': 'Click Engagement' ,
        'button_name': name,
        'click_detail': url
    });
}
